<template>
    <div>
        <van-config-provider :theme-vars="themeVars">
            <router-view v-slot="{ Component }">
                <keep-alive :include="$store.state.keep_live_route">
                    <component :is="Component"></component>
                </keep-alive>
            </router-view>
        </van-config-provider>
    </div>
</template>

<script setup>
    import {
        ref,
        onBeforeMount
    } from 'vue'
    const themeVars = ref({
        'ButtonPrimaryBackgroundColor': 'linear-gradient( 90deg, #FF4C1D 0%, #FFA845 100%)',
        'ButtonPrimaryBorderColor': '#FF4C1D',
        'CcascaderActiveColor': '#FF4C1D',
        'RadioCheckedIconColor': '#FF4C1D',
        'FieldInputDisabledTextColor': '#999',
        'FieldPlaceholderTextColor': '#999999',
        'CalendarRangeEdgeColor': '#fff',
        'CalendarRangeEdgeBackgroundColor': '#FF4C1D',
        'CalendarSelectedDayBackgroundColor': '#FF4C1D',
        'PickerConfirmActionColor': '#FF4C1D',
        'bg_color_qs': '#FFF5F0',
        'bg_c_jb': 'linear-gradient( 90deg, #FF4C1D 0%, #FFA845 100%)'
    })
</script>
<style>
    @import '@/assets/css/app.less';
</style>